import { MouseEvent, PropsWithChildren } from 'react'
import { Link } from '@vp/swan'
import { LinkWithQueryProps } from '~/app/components/LinkWithQuery/interface'
import { useDispatch } from 'react-redux'
import { useGalleryUrl } from '~/app/features/Gallery/hooks/useGalleryUrl'
import { useSearchParams } from '~/app/features/Gallery/hooks/useSearchParams'
import { setQuickViewId } from '~/app/store/debug/actions'
import { ThunkDispatch } from '~/app/store/interface'

export const LinkWithQuery = ({ children, designId, currentDesignId, onClick, noFollow, className }: PropsWithChildren<LinkWithQueryProps>) => {
  const dispatch = useDispatch<ThunkDispatch>()
  const url = useGalleryUrl()
  const searchParams = useSearchParams()

  searchParams.forEach((value, key) => {
    url.searchParams.set(key, value)
  })

  url.searchParams.set('qv', designId)

  const handleClick = (event: MouseEvent<HTMLAnchorElement>): void => {
    event.preventDefault()
    onClick?.()
    dispatch(setQuickViewId(designId))

    // This hack appeared after migration from `react-router-dom` in order to set `designId` to `window.history.state`. It doesn't do anything else.
    window.history.replaceState({ ...window.history.state, designId: currentDesignId, usr: { designId: currentDesignId } }, '')
  }

  return (
    <Link onClick={handleClick} href={url.toString()} rel={noFollow ? 'nofollow' : undefined} style={{ display: 'inherit' }} className={className}>
      {children}
    </Link>
  )
}
